<action-box class="prices-detail detail-item "
            iconLeft="bom"
            textLeft="{{decoration?.title}}">

  <div class="dataselector-table decoration" [style.max-width.%]="'100'">

    <gridview classes="useBorder text-center">

      <gridview-header>
        <header-columntemplate *ngFor="let column of columns"
                               title="{{column.contents}}"
                               [ngStyle]="column.safeStyle"
                               [classes]="column.classes"
                               [name]="column.longId">
          <span>
            {{column.contents}}
          </span>
        </header-columntemplate>
      </gridview-header>

      <!-- Different template depending on hyperlink or not, hyperlink should not have onValueClick -->
      <gridview-row *ngFor="let row of rows; trackBy: trackRow"
                    [classes]="row.classes">
        <!-- NOTE! Selected is not needed here as createTable will be called after we a value has been set. -->
        <ng-container *ngFor="let cell of row.cells">
          <ng-container *ngIf="cell.href || cell.image; else contents">
            <columntemplate [classes]="cell.classes + ' justify-content-center align-middle'" [size]="cell.size" title="{{cell.href}}" [ngStyle]="cell.safeStyle">
              <a *ngIf="cell.href" href="{{cell.href}}" class="d-block" target="_blank">
                <co-image *ngIf="!cell.image" width="24px" height="24px" type="svg" key="link"></co-image>
              </a>
              <co-image *ngIf="cell.image" type="png" [isVault]="true" [key]="cell.contents"></co-image>
            </columntemplate>

          </ng-container>
          <ng-template #contents>
            <columntemplate [classes]="cell.classes" [size]="cell.size" title="{{cell.contents}}" [ngStyle]="cell.safeStyle">
              {{cell.contents}}
            </columntemplate>
          </ng-template>
        </ng-container>
      </gridview-row>
    </gridview>

    <div card-type="footer" *ngIf="showPager">
      <pager [pagerModel]="pagerModel"
             [initialWidth]="width"
             (pagerUpdated)="refreshPage()"></pager>
    </div>
  </div>

</action-box>